<template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentImage="contentImage"
      :contentHeading="contentHeading"
      buttonText="Start Onboarding"
      :previousLink="previousLink"
      backText="Watch Video"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import Guide from '@/components/Guide'

export default {
  name: 'OnboardingIntro',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    ...mapState(['currentUser']),

    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-video',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-pages',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    firstName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[0]
    },

    contentHeading() {
      return `Hello, ${this.firstName} – A quick message`
    },

    content() {
      return `
        <p>I wanted to personally thank you for using our brand new platform, PageMakerPro! This project has been in development for just over 2 years and we're so excited to have you on it.</p>

        <p>We're providing you early access, and while some features can be new and exciting, they may not yet be 100% stable. Their code and components are complete for the most part, but there may still be some tweaks required that you can help bring to our attention. </p>

        <p>We want to hear from you, ${this.firstName}. So let us know: Are you missing something you need? Do you see any bugs? Is there a feature that's frustrating to use? Anything at all, just let us know by using the <strong>Chat with us</strong> tab on the right.</p>
        `
    },

    contentImage() {
      return require('../../../assets/probot.svg')
    }
  }
}
</script>
